// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2vDW8","logout":"Header_logout__2nMCp","header__imgWrapper":"Header_header__imgWrapper__2v8Oy"};